export type PlanProgressReadState = 'VALUE' | 'NOT_APPLICABLE' | 'ERROR';

export type CanonicalPlanProgressState = {
    state: PlanProgressReadState;
    value: number | null;
};

type ResolveCanonicalPlanProgressStateInput = {
    readError?: string | null;
    totalGoal: number;
    canonicalPercentage: number | null;
};

/**
 * Preserves the percentage produced from the canonical live plan totals.
 * This resolver owns availability semantics only; it intentionally does not
 * recalculate goal/progress or inspect KPI, workflow, approval, or period state.
 */
export const resolveCanonicalPlanProgressState = ({
    readError,
    totalGoal,
    canonicalPercentage
}: ResolveCanonicalPlanProgressStateInput): CanonicalPlanProgressState => {
    if (readError) return { state: 'ERROR', value: null };
    if (!(Number(totalGoal) > 0)) return { state: 'NOT_APPLICABLE', value: null };
    if (canonicalPercentage === null || !Number.isFinite(canonicalPercentage)) {
        return { state: 'ERROR', value: null };
    }
    return { state: 'VALUE', value: canonicalPercentage };
};
